
        import { h, render, defineComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from 'vue';
        const __svgComponent = defineComponent({
          

 render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      d: "M12.7002 1.66699H7.30019C4.16686 1.66699 3.92519 4.48366 5.61686 6.01699L14.3835 13.9837C16.0752 15.517 15.8335 18.3337 12.7002 18.3337H7.30019C4.16686 18.3337 3.92519 15.517 5.61686 13.9837L14.3835 6.01699C16.0752 4.48366 15.8335 1.66699 12.7002 1.66699Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ]))
},
          mounted() {
            // Mount logic
          },
          unmounted() {
            // Unmount logic
          }
        });

        export default __svgComponent;
        